<template>
  <v-menu
      v-model="menu"
      offset-y
      :min-width="minWidth"
  >
    <template v-slot:activator="{ on }">
      <div v-on="disabled ? ()=>{} : on ">
        <TextField
            theme="3"
            :placeholder="placeholder"
            class="picker-field"
            :clearable="true"
            :readonly="true"
            :disabled="disabled"
            :label="label"
            min-width="235px"
            max-width="235px"
            :value="value"
            :rules="rules"
            @onClear="eventClear"
        ></TextField>
      </div>
    </template>
    <v-date-picker
        color="var(--theme-color-one)"
        :allowed-dates="allowedDate"
        :disabled="disabled"
        :value="value"
        @input="eventInput"
    ></v-date-picker>
  </v-menu>
</template>

<script>
import TextField from "./TextField"

export default {
  name: "DatePicker",
  components: {
    TextField
  },
  props: {
    rules: {
      type: Array,
      default: () => [],
    },
    value: {
      default: undefined
    },
    label: {
      default: ''
    },
    maxDate: {
      default: null
    },
    minWidth: {
      default: 'auto'
    },
    minDate: {
      default: null
    },
    placeholder: {
      default: 'โปรดระบุ'
    },
    customAllowDates: {
      type: Boolean,
      default: false
    },
    disabled:{
      default: false
    },
    allowedDates: {
      default: () => {}
    }
  },
  data () {
    return {
      menu: false
    }
  },
  methods: {
    eventInput (val) {
      this.$emit('onInput', val)
    },
    allowedDate (date) {
      if (this.customAllowDates) {
        return this.allowedDates(date)
      }
      if (this.maxDate && this.minDate) return date <= this.maxDate && date >= this.minDate
      if (this.maxDate) return date <= this.maxDate
      if (this.minDate) return date >= this.minDate
      return true
    },
    eventClear () {
      this.$emit('onClear')
    }
  }
}
</script>

<style scoped>

</style>